<ng-container *ngIf="!isAcmic && where === 'e-bill'; else other">
  <mapfre-modal [modalOptions]="endEnrollOptionsModal" [hideModal]="hideModal" (hideModalOutput)="resetHideModal()"
    (click)="resetHideModal()">
    <div class="modal-body" [ngClass]="{ 'unenroll-me e-bill-unenroll': !isAcmic }">
      <ng-container *ngIf="!isAcmic">
        <div class="margin-bottom mb24">
              <img alt="warning icon" src="./assets/img/images/icon-warning-enroll-paperless-ma.svg">
        </div>
      </ng-container>
      <div class="e-bill-text">
        <div class="confirm-text-sub-container">
          <div>{{ 'UNENROLL_CONFIRM_TEXT' | translate }} {{ policy?.displayType?.label }} {{ 'POLICY_PAPERLESS' | translate }} {{ policy?.policynumber.policyNumber }} {{ 'FROM_E-BILL' | translate }}</div>
        </div>
      </div>
      <hr class="paperless-hr" />
      <div class="mx-auto text-center acmic-unenroll-btn unenroll-btns-container">
        <div [ngClass]="{ 'align-item unenroll-paperless-confirm': !isAcmic }">
          <mapfre-button [ngClass]="{'custom_loader':custom_loader}" [disabledValue]="!custom_loader"
            additionalClasses="basic default large-btn" (click)="cancel(policyNumber);">
            {{ 'UNENROLL' | translate }}
          </mapfre-button>
        </div>
        <ng-container *ngIf="isAcmic; else maCancelBtn">
          <div class="margin-top mt24">
            <mapfre-button additionalClasses="ghost secondary large-btn cancel-btn" (click)="hideModalAction($event)">
              {{ 'CANCEL' | translate }}
            </mapfre-button>
          </div>
        </ng-container>
        <ng-template #maCancelBtn>
          <div class="align-item unenroll-paperless-cancel">
            <mapfre-button additionalClasses="ghost secondary h56 warn-ghost unenroll-cancel-btn"
              (click)="hideModalAction($event)">
              {{ 'KEEP_ME_ENROLLED' | translate }}
            </mapfre-button>
          </div>
        </ng-template>
      </div>
    </div>
  </mapfre-modal>
</ng-container>
<ng-template #other>
  <mapfre-modal [modalOptions]="endEnrollOptionsModal" [hideModal]="hideModal" (hideModalOutput)="resetHideModal()"
    (click)="resetHideModal()" [ngClass]="{'acmic-hide-header': isAcmic}">
     <div class="enroll-header" *ngIf="isAcmic">
          <img src="assets/img/images/icon-close-paperless-acmic.svg" class="show-more-button" />
    </div> 
    <div class="modal-body" [ngClass]="{ 'unenroll-me': !isAcmic }">
      <ng-container *ngIf="!isAcmic">
        <div *ngIf="where === 'e-policy'">
          <div class="unenroll-warning-container">
              <img alt="Otp" src="./assets/img/images/icon-warning-enroll-paperless-ma.svg">
          </div>
        </div>
        <div *ngIf="where === 'e-bill'">
          <div class="unenroll-warning-container">
              <img alt="warning icon" src="./assets/img/images/icon-warning-enroll-paperless-ma.svg">
          </div>
        </div>
      </ng-container>
      <hr *ngIf="!isAcmic" class="margin-bottom mb24 no-margin-top" />
      <div *ngIf="isAcmic" class="warning-unenroll-container">
        <img alt="warning icon" src="./assets/img/images/icon-warning-enroll-paperless-acmic.svg">
      </div>
      <div class="text-padding-class" [ngClass]="{ 'title-width': !isAcmic, 'unenroll-text-acmic': isAcmic }"
        *ngIf="where === 'e-policy' else bill">
        <div class="confirm-text-sub-container">
          {{ 'UNENROLL_CONFIRM_TEXT' | translate }}<br *ngIf="!isAcmic"> {{ policy?.displayType?.label }} {{ 'POLICY_PAPERLESS' | translate }} {{ policy?.policynumber.policyNumber }} {{ 'FROM_E-POLICY' | translate }} 
        </div>
      </div>
      <ng-container *ngIf="isAcmic">
        <hr class="paperless-hr" />
      </ng-container>
      <ng-container *ngIf="!isAcmic">
        <hr class="paperless-hr" *ngIf="where === 'e-policy'" />
      </ng-container>
      <ng-template #bill>
        <div class="text-padding-class">
          <p class="confirm-text-sub-container">
            {{ 'REMOVE_POLICY_FROM_EBILL' | translate }}
          </p>
        </div>
      </ng-template>
      <div class="mx-auto text-center acmic-unenroll-btn unenroll-btns-container-gw">
        <div [ngClass]="{ 'align-item unenroll-btns-unenroll': !isAcmic }">
          <mapfre-button [ngClass]="{'custom_loader':custom_loader}" [disabledValue]="!custom_loader"
            additionalClasses="basic default large-btn" (click)="cancel(policyNumber);">
            <ng-container *ngIf="isAcmic else maUNenroll">
              {{ 'REMOVE_POLICY' | translate }}
            </ng-container>
            <ng-template #maUNenroll>
              {{ 'UNENROLL' | translate }}
            </ng-template>
          </mapfre-button>
        </div>
        <ng-container *ngIf="isAcmic; else maCancelBtn">
          <div class="margin-top mt24" [ngClass]="{'unenroll-cancel-btn-acmic': isAcmic}">
            <mapfre-button additionalClasses="ghost secondary large-btn cancel-btn" (click)="hideModalAction($event)">
              {{ 'CANCEL' | translate }}
            </mapfre-button>
          </div>
        </ng-container>
        <ng-template #maCancelBtn>
          <div class="align-item unenroll-btns-cancel">
            <mapfre-button additionalClasses="ghost secondary h56 warn-ghost unenroll-cancel-btn"
              (click)="hideModalAction($event)">
              {{ 'KEEP_ME_ENROLLED' | translate }}
            </mapfre-button>
          </div>
        </ng-template>
      </div>
    </div>
  </mapfre-modal>
</ng-template>